import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconWellPresetALTSizeM from './IconWellPresetALT_size_m';

const props: CreateIconArguments = {
  l: IconWellPresetALTSizeM,
  m: IconWellPresetALTSizeM,
  s: IconWellPresetALTSizeM,
  xs: IconWellPresetALTSizeM,
  name: 'IconWellPresetALT',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
